// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2hOre","fileBtn":"File_fileBtn__fTWsb","closeBtn":"File_closeBtn__1At3n","fileSelected":"File_fileSelected__1j72P","disabled":"File_disabled__3zReQ"};